/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClearIcon from "@mui/icons-material/Clear";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  Box,
  Avatar,
  Modal,
  Snackbar,
  Button,
  Alert,
  IconButton,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import DocumentUpload from "../components/DocumentUpload";
import { connect } from "react-redux";
import { RestartAlt, ZoomIn, ZoomOut } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

const getCompanyUserProfile = async (user, setMyState, company) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    let url = "";
    if (authData?.type === "customer_user") {
      url = `/api/v1/customer_user/ops/${user}`;
    } else {
      url = `/api/v1/${authData?.type}/customer_company_user/${user}`;
    }
    const { data } = await axios.get(url, config);
    if (data.success) {
      setMyState((prev) => {
        return { ...prev, profile: data.data };
      });
      setLinks(data.data.documents, setMyState, company);
    }
  } catch (e) {
    console.log(e);
  }
};

const getUrls = async (documents, setUrls, setLoader) => {
  try {
    setLinks(documents, setUrls, setLoader);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

const setLinks = (document, setMyState, company) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/${authData?.type}/${company}/media/${doc.document_storage_info.key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`;
      }
      urls.push({
        url: url,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setMyState);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
    }
    let n = 0;
    let allUrls = [];
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          }
          if (n === num) {
            setMyState((prev) => {
              return { ...prev, urls: allUrls };
            });
            setMyState((prev) => {
              return { ...prev, loader: false };
            });
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    console.log(e);
  }
};

const getRolesCompanies = async (setRoles, setCompanies, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const roledata = await axios.get(
      `/api/v1/${userData.type}/role?user_type=customer_company_user`,
      config
    );

    const companydata = await axios.get(
      `/api/v1/${userData.type}/customer_company?limit=500`,
      config
    );
    if (roledata.data.success) {
      setRoles(roledata.data.data);
    }
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function DefaultTextFields({ profile, urls, id, comp, loader }) {
  const [del, setDelete] = useState(false);
  const [message, setMessage] = useState("");
  // useEffect(() => {
  //   console.log(urls);
  // }, [urls]);
  const [company, setCompany] = useState(profile?.customer_company?.name);
  const [role, setRole] = useState(profile?.role?.role_name);
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const [roles, setRoles] = useState([]);
  const [load, setLoader] = useState(false);
  useEffect(() => {
    // getRolesCompanies(setRoles, setCompanies, setLoader);
  }, [profile]);
  const [open, setOpen] = React.useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpen = (url, type) => {
    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
  };
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setState({ ...state, op: false });
  };
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const formData = new FormData();
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});

  const deleteDocument = async (key) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/${authData?.type}/${comp}/media/customer_user/${id}/${key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/customer_user/${id}/${key}`;
      }
      const { data } = await axios.delete(url, config);
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        window.location.reload();
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  const addDocuments = async () => {
    try {
      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        setLoader(true);
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        let url = "";
        if (authData?.type === "customer_user") {
          url = `/api/v1/${authData?.type}/${comp}/media/customer_user/${id}`;
        } else {
          url = `/api/v1/${authData?.type}/media/customer_user/${id}`;
        }
        const { data } = await axios.post(url, formData, config);
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added successfully");
          snackRef.current.click();
          window.location.reload();
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };
  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={op}
        onClose={handleCloseSnack}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        ) : null}
      </Snackbar>
      {!loader ? (
        <form noValidate autoComplete="off">
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom>
                      Customer User Profile Page
                    </Typography>
                  </Grid>
                  {urls.map((url, i) => {
                    if (url.name === "profile_picture") {
                      return <BigAvatar src={url.url} />;
                    }
                  })}
                  <Grid item xs={12} md={12} lg={12}></Grid>

                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-required"
                      value={company}
                      inputProps={{ readOnly: true }}
                      label="Company"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-required"
                      value={profile?.name}
                      inputProps={{ readOnly: true }}
                      label="Name"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-required"
                      value={profile?.email_address}
                      inputProps={{ readOnly: true }}
                      label="Email"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      value={profile?.phone_number}
                      inputProps={{ readOnly: true }}
                      id="standard-required"
                      label="Mobile"
                    />
                  </Grid>

                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      value={role}
                      inputProps={{ readOnly: true }}
                      label="Role"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      label="Address Line 1"
                      value={profile?.address_line_one}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      label="Address Line 2"
                      value={profile?.address_line_two}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      label="Pincode"
                      value={profile?.pincode}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      label="State"
                      value={profile?.state}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      label="City"
                      value={profile?.city}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>

          <Modal open={open} onClose={handleClose}>
            <Card sx={style}>
              <CardContent>
                <Paper>
                  <Grid container justifyContent="center" spacing={5}>
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight + 5)}
                      >
                        <ZoomIn />
                      </IconButton>
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight - 5)}
                      >
                        <ZoomOut />
                      </IconButton>
                      <IconButton onClick={() => setModalImgHeight(70)}>
                        <RestartAlt />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        maxHeight: "72.5vh",
                        overflowY: "scroll",
                      }}
                    >
                      {type !== "pdf" ? (
                        <Box
                          component={"img"}
                          src={u}
                          height={modalImgHeight.toString() + "vh"}
                          width="auto"
                        />
                      ) : (
                        <iframe
                          height={(modalImgHeight + 420).toString() + "vh"}
                          width={(modalImgHeight + 420).toString() + "vh"}
                          src={u}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </Modal>
          <Modal
            open={openAddDoc}
            onClose={handleDownDoc}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                align="center"
                color="primary"
              >
                Add Documents
              </Typography>
              <DocumentUpload
                documents={documents}
                setDocuments={setDocuments}
                images={images}
                setImages={setImages}
              />
              <Button onClick={addDocuments}>Add</Button>
            </Box>
          </Modal>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h4" gutterBottom>
                      Document Details
                    </Typography>
                  </Grid>
                </Grid>
                {!profile.documents.length ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary" gutterBottom>
                      No Documents Added
                    </Typography>
                  </Grid>
                ) : null}
                {profile.documents &&
                  profile.documents.map((document, i) => {
                    if (urls[i]?.name !== "profile_picture") {
                      return (
                        <Paper
                          style={{ display: "flex", alignItems: "center" }}
                          mt={3}
                        >
                          <Box
                            component="img"
                            width="90px"
                            height="80px"
                            onClick={() =>
                              handleOpen(urls[i]?.url, urls[i]?.type)
                            }
                            src={
                              urls[i]?.type === "pdf"
                                ? "/static/img/images/pdf.png"
                                : urls[i]?.url
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <TextField
                            fullWidth
                            margin="dense"
                            m={2}
                            style={{ marginLeft: 32 }}
                            inputProps={{ readOnly: true }}
                            id="standard-required"
                            label="Document Name"
                            value={urls[i]?.name || ""}
                          />
                          {!del ? (
                            <Mob>
                              <Grid item>
                                <a
                                  href={urls[i]?.url}
                                  style={{
                                    color: "inherit",
                                    textDecoration: "inherit",
                                  }}
                                  download={`${urls[i]?.name}.${urls[i]?.type}`}
                                >
                                  <FileDownloadIcon
                                    style={{
                                      marginLeft: 32,
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </Grid>
                            </Mob>
                          ) : (
                            <Grid item>
                              <ClearIcon
                                onClick={() => deleteDocument(urls[i]?.key)}
                                style={{
                                  marginLeft: 32,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          )}
                        </Paper>
                      );
                    }
                  })}
              </Paper>
            </CardContent>
          </Card>
        </form>
      ) : (
        <Loading />
      )}
    </>
  );
}

function CustomerUserProfile({ auths }) {
  const { user_id } = useParams();
  const navigate = useNavigate();

  const [myState, setMyState] = useState({
    profile: {},
    urls: [],
    loader: true,
  });

  useEffect(() => {
    getCompanyUserProfile(
      user_id,
      setMyState,
      auths?.user?.customer_company?._id
    );
  }, []);
  if (!myState.loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CUSTOMER USER PROFILE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/users/customer-users">
                Customer Users
              </Link>
              <Typography>Profile </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <DefaultTextFields
              comp={auths?.user?.customer_company?._id}
              id={user_id}
              urls={myState.urls}
              profile={myState.profile}
              loader={myState.loader}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(CustomerUserProfile);
